module.exports = __webpack_public_path__ + "static/img/banner01.add2d90.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/banner01.png
// module id = 927
// module chunks = 0